import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function ProtectedRoute({ children, roles, allowMustChange }) {
  const { loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F6F9]">
        <div className="text-sm text-[#6b7c6e]">Chargement…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user.actif === false) {
    return <Navigate to="/login" replace state={{ reason: 'inactive' }} />;
  }

  // Force change-password page if flagged (and we're not already there)
  if (user.must_change_password && !allowMustChange) {
    return <Navigate to="/change-password" replace />;
  }

  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    const r = user.role;
    if (r === 'agent') return <Navigate to="/agent" replace />;
    if (r === 'admin_region' || r === 'admin_commune') return <Navigate to="/dashboard-admin" replace />;
    if (r === 'superadmin') return <Navigate to="/" replace />;
    if (r === 'viewer') return <Navigate to="/carte" replace />;
    return <Navigate to="/carte" replace />;
  }

  return children;
}
